import React, { Component } from 'react';

import { AgGridReact } from "@ag-grid-community/react";
import { Loader } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
// import StateSynchronizer from '../../../../../utils/StateSynchronizer';

class ThirteenFLongPosReportGrid extends Component {

  constructor(props) {
    super(props);

    this.state = {
      columnDefs: props.thirteenFLongPosReportGridColumns,
      defaultColDef: {
        enableCellChangeFlash: true,
        minWidth: 100,
        sortable: true,
        filter: true,
        resizable: true,
      },
      groupDefaultExpanded: 0,
    };
  }

  getRowNodeId = data => {
    return data.id;
  };

  onGridReady = params => {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;

    this.gridApi.closeToolPanel();

    // const COLUMNS_KEY = 'trade--report-grid-col-state';

    // StateSynchronizer.syncGrid(
    //   params,
    //   this.state.columnDefs,
    //   () => localStorageClient.getGridColumnState(COLUMNS_KEY),
    //   s => localStorageClient.saveGridColumnState(COLUMNS_KEY, s)
    // );
  };

  render() {
    const {
      thirteenFLongPosReportArray,
      className = 'grid-wrapper',
      loadThirteenFLongPosReportActionStatus
    } = this.props;

    const isLoading = loadThirteenFLongPosReportActionStatus === ACTION_STATUS.LOGINING;
    if (loadThirteenFLongPosReportActionStatus === ACTION_STATUS.SUCCESS) {
      this.props.initLoadThirteenFLongPosReportActionStatus();
    }

    return (
      <div className={`ag-theme-balham ${className}`}>
        {isLoading ? (
          <Loader active content="Loading..." />
        ) : (
          <AgGridReact
            // properties
            columnDefs={this.state.columnDefs}
            rowData={thirteenFLongPosReportArray}
            defaultColDef={this.state.defaultColDef}
            rowSelection={this.state.rowSelection}
            rowClassRules={this.state.rowClassRules}
            animateRows={true}
            immutableData={false}
            resizable={true}
            sideBar={true}
            getRowNodeId={this.getRowNodeId}
            // master/detail
            masterDetail={true}
            detailCellRendererParams={this.state.detailCellRendererParams}
            getRowHeight={this.state.getRowHeight}
            groupDefaultExpanded={this.state.groupDefaultExpanded}
            // events
            onGridReady={this.onGridReady}
            onSelectionChanged={this.onSelectionChanged}
          />
        )}
      </div>
    );
  }
}

export default ThirteenFLongPosReportGrid;